import { Button } from 'antd'

import { cx } from '@/Ship/Helpers/cssClass'

import styles from './Report.module.css'

/** Порожній стан таблиці звіту: чому порожньо і що зробити */
export const ReportEmpty = ({ hasFilters, allTime }: { hasFilters: boolean; allTime: boolean }) => {
    let hint = 'Спробуйте інший період — наприклад, «Минулий місяць» або «Квартал».'
    if (hasFilters)
        hint = allTime ? 'Спробуйте зняти частину фільтрів.' : 'Спробуйте розширити період або зняти частину фільтрів.'
    else if (allTime) hint = 'Підтверджених задач у системі ще немає.'
    return (
        <div className={cx(styles, 'empty')}>
            <p className={cx(styles, 'emptyTitle')}>
                {allTime ? 'Немає підтверджених задач' : 'Немає підтверджених задач за цей період'}
            </p>
            <p className={cx(styles, 'emptyHint')}>{hint}</p>
        </div>
    )
}

/** Помилка завантаження звіту з повтором */
export const ReportError = ({ message, onRetry }: { message: string; onRetry: () => void }) => (
    <div className={cx(styles, 'empty')} role="alert">
        <p className={cx(styles, 'emptyTitle')}>{message}</p>
        <Button size="small" onClick={onRetry} style={{ marginTop: 8 }}>
            Повторити
        </Button>
    </div>
)
